import { createApiRef } from '@backstage/core-plugin-api';
import { GitflicApi } from './GitflicApi';
import {
  GitflicArtifact,
  GitflicBranch,
  GitflicCicdVariable,
  GitflicJob,
  GitflicPage,
  GitflicPipeline,
  GitflicPipelineStartVariable,
  GitflicTag,
} from './types';

export const gitflicPipelinesApiRef = createApiRef<GitflicPipelinesApi>({
  id: 'plugin.gitflic-pipelines.service',
});

export interface GitflicPipelinesApi extends GitflicApi {
  listBranches(projectSlug: string): Promise<GitflicBranch[]>;
  listTags(projectSlug: string): Promise<GitflicTag[]>;
  listCicdVariables(projectSlug: string): Promise<GitflicCicdVariable[]>;
  listProjectPipelines(
    projectSlug: string,
    options?: {
      page?: number;
      size?: number;
      sort?: { field: string; direction: 'ASC' | 'DESC' };
      branch?: string;
      tag?: string;
    },
  ): Promise<{ items: GitflicPipeline[]; page?: GitflicPage }>;
  listPipelineJobs(
    projectSlug: string,
    pipelineLocalId: number,
    options?: {
      page?: number;
      size?: number;
      sort?: { field: string; direction: 'ASC' | 'DESC' };
    },
  ): Promise<{ items: GitflicJob[]; page?: GitflicPage }>;
  listPipelineArtifacts(
    projectSlug: string,
    pipelineLocalId: number,
  ): Promise<GitflicArtifact[]>;
  startPipeline(
    projectSlug: string,
    options?: {
      refName?: string;
      isTag?: boolean;
      variables?: GitflicPipelineStartVariable[];
    },
  ): Promise<{ pipelineUuid?: string }>;
  restartPipeline(projectSlug: string, pipelineLocalId: number): Promise<void>;
  cancelPipeline(projectSlug: string, pipelineLocalId: number): Promise<void>;
  deletePipeline(projectSlug: string, pipelineLocalId: number): Promise<void>;
  restartJob(projectSlug: string, jobLocalId: number): Promise<void>;
  cancelJob(projectSlug: string, jobLocalId: number): Promise<void>;
  downloadArtifact(downloadUrl: string): Promise<Blob>;
}
